import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { DataService } from 'src/app/services/data.service';
import { MappingService } from 'src/app/services/mapping.service';
import { Environment } from 'src/app/stores/environment.store';
import { ExcelStore } from 'src/app/stores/excelStore';

@Component({
  selector: 'app-import-cam-reading-student',
  templateUrl: './import-cam-reading-student.component.html',
  styleUrls: ['./import-cam-reading-student.component.scss']
})
export class ImportCamReadingStudentComponent implements OnInit {
  tabs = TESTING_CENTER.IMPORT_STUDENT

  form: FormGroup;
  organization: AbstractControl;
  reading_batch: AbstractControl;
  year: AbstractControl;

  filteredOrganizationOptions: Observable<[]>;
  filteredBatchOptions: Observable<[]>;
  filteredYearOptions: Observable<[]>;
  constructor(
    public store: ExcelStore,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    public ds: DataService,
    private env: Environment

  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      organization: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      reading_batch: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      year: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
    })
    this.organization = this.form.controls['organization'];
    this.reading_batch = this.form.controls['reading_batch'];
    this.year = this.form.controls['year'];
    await this.env.getUserData()
    let organizationList = await this.store.fetchList(this.ds.dbRef().collection("organizations", ref => ref
      .orderBy("name")))
    organizationList = MappingService.orderBy(organizationList, "name")
    this.filteredOrganizationOptions = MappingService.autoComplete(this.organization, MappingService.orderBy(organizationList, "name"), 'name')
    this.store.xlcData = []
  }

  async optionSelected(event) {
    this.form.patchValue({
      year: null,
      reading_batch: null,
    })
    const { value } = event.option;
    if (value && value.key) {
      const yearList = await this.store.fetchList(this.ds.dbRef().collection("organizations").doc(value.key).collection('academic_year'))
      const yearData = MappingService.orderBy(yearList, "name")
      this.filteredYearOptions = MappingService.autoComplete(this.reading_batch, yearData, 'name')
    }
  }


  async optionSelectedYear(event) {
    const { value } = event.option;
    if (value && value.key) {
      let batchList = await this.store.fetchList(this.ds.dbRef().collection("reading_batches", ref => ref
        .where("academicYear.key", "==", value.key)
      ))
      batchList = MappingService.orderBy(batchList, "name")
      this.filteredBatchOptions = MappingService.autoComplete(this.reading_batch, batchList, 'name')
    }
  }


  displayItem(item: any): string {
    return item ? item.name : item;
  }

  onChanged(event) {
    const { checked } = event;
    if (checked) {
      this.form.controls['officer'].enable()
      this.form.controls['provinceInspection'].enable()
    } else {
      this.form.controls['officer'].disable()
      this.form.controls['provinceInspection'].disable()
    }
  }

  clear() {
    this.store.xlcData = []
  }

  onSelectedFile(ev) {
    this.store.fileCamReadingChange(ev);
  }

  create(f: any) {
    if (this.form.valid) {
      const { user } = this.env
      if (this.store.xlcData.length === 0 || this.store.xlcData.filter(m => m.isExist === true).length > 0) return
      this.store.importStudentCamReading(this.store.xlcData, f, user, (success, res) => {
        if (success) {
          this.form.patchValue({
            reading_batch: null,
          })
          this.snackBar.open(`Import has been imported successful.`, "Done", { duration: 1000 });

        } else {
          this.snackBar.open(`${res}`, "Error", { duration: 3000 });
        }
      })
    }

  }

}
